import React, { useEffect } from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { Domingo } from '@fiverr-private/domingo';
import { getContext } from '@fiverr-private/fiverr_context';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Image } from '@fiverr-private/media';
import { Text } from '@fiverr-private/typography';
import { reportBannerIsShown, reportClickBanner } from './bqReports';

import { container } from './styles.ve.css';

const getCtaUrl = () => {
    const baseUrl = Domingo(getContext().url).pro().url;
    const url = new URL(baseUrl);
    url.searchParams.set('source', 'pro_toggle');
    return url.toString();
};

const onCtaClick = () => reportClickBanner();

export const FiProEntryBanner = () => {
    useEffect(() => {
        reportBannerIsShown();
    }, []);

    return (
        <Stack
            maxHeight={{ default: 'auto', md: '174px' }}
            className={container}
            paddingX="8"
            paddingY={{ default: '6', lg: '8' }}
            borderRadius="lg"
            marginTop="1"
            marginBottom="1"
            direction="row"
            alignItems="center"
            justifyContent="spaceBetween"
            gap={{ default: '0', sm: '14', md: '20' }}
        >
            <Stack direction="column" gap={{ default: '3', sm: '5' }}>
                <Text color="white" size={{ default: 'b_xl', md: 'b_xxl' }}>
                    {translate('search_perseus.fip_entry_banner.title', {
                        templates: {
                            domaine: (text) => (
                                <Text as="span" fontWeight="bold" color="white" size={{ default: 'b_xl', md: 'b_xxl' }}>
                                    {text}
                                </Text>
                            ),
                        },
                    })}
                </Text>
                <Container>
                    <Button
                        colorScheme="white"
                        intent="primary"
                        variant="filled"
                        href={getCtaUrl()}
                        target="_blank"
                        onClick={onCtaClick}
                    >
                        {translate('search_perseus.fip_entry_banner.cta')}
                    </Button>
                </Container>
            </Stack>
            <Container display={{ default: 'none', sm: 'flex' }}>
                <Image
                    width={{ default: '100%', sm: '180px', md: '220px' }}
                    src="https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/2a0092ad6426443fd62a6c2cb769c8b4-1747208446987/Asset.png"
                    alt="Fip Pro Entry Banner"
                />
            </Container>
        </Stack>
    );
};

export default FiProEntryBanner;
